import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import {
  Heading,
  Section,
} from '@piggybank/core';

import {
  Fieldset,
  Hint,
  Radio,
} from '@piggybank/form';

import { formatAmountByValue } from '~/genericFunctions';
import { NLS } from '~/pages/PayrollReview/payrollReviewFunctions';

import { withAppContext } from '~/AppContext';

const LoanOptions = ({ data }) => {
  let loanOptions = get(data, 'displayData.loanOffer.loanOptions');
  return (
    <Section>
      <Heading accentBar level={2}>
        {NLS`Loan details`}
      </Heading>

      <Fieldset name="loanAmountIndex" role="radiogroup">
        {loanOptions.map((option, index) => (
          <Radio key={index} value={index}>{formatAmountByValue(get(option, 'principal.amount'))}
            <Hint>{NLS`with payments of`} {formatAmountByValue(get(option, 'payment.amount.amount'))}</Hint>
          </Radio>
        ))}
      </Fieldset>
    </Section>
  );
};

LoanOptions.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      loanOffer: PropTypes.shape({
        loanOptions: PropTypes.arrayOf(PropTypes.shape()),
      }),
    }),
  }),
};

export default withAppContext()(LoanOptions);
